import * as yup from 'yup';

export const AllergySchema = yup.object({
  name: yup.string().required(),
  description: yup.string().required(),
});

export interface IAllergy {
  name: string;
  description: string;
}
